import { FullFileType } from '@/modules/FileList/types/FileList.type.ts';
import { FileListActionTypes } from '@/modules/FileList/components/fileDetailCardActions/FileListlAction.type.ts';

export const myFilesDetailCardActionsGenerator = (
  data: FullFileType,
): FileListActionTypes => {
  const actions = data.action.map((action) => action.const);
  if (actions.includes('accept_file') && actions.includes('reject_file')) {
    return 'acceptOrReject';
  }
  if (actions.includes('edit_visit_time') && data.has_file_entry) {
    return 'enterAndEditTime';
  }
  if (actions.includes('accept_file')) {
    return 'accept';
  }
  return 'enter';
};
